import BreadCrumbs from './BreadCrumbs';

const homeBreadcrumbs = BreadCrumbs.builder([{ label: 'Home', to: '/' }]);
export default homeBreadcrumbs;
